module.exports = __webpack_public_path__ + "static/media/final-status.38d8dbf8.svg";